<template>
  <div class="cpt-list-header">
    <HeaderAvatar
      :hasBorder="false"
      :image="'https://static.max-c.com/static/heybox/webapp/game/palworld/database/game-logo.png'"
    />
    <div class="info">
      <div class="row-1">{{ title }}</div>
      <div class="row-2">{{ desc }}</div>
    </div>
  </div>
</template>

<script>
import HeaderAvatar from '_com/base/HeaderAvatar.vue';
export default {
  components: {
    HeaderAvatar,
  },
  props: {
    title: {
      type: String,
      default: '幻兽帕鲁图鉴',
    },
    desc: {
      type: String,
      default: '点击帕鲁条目查看详细数据',
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.cpt-list-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px 12px 10px;
  .info {
    margin-left: 10px;
    .row-1 {
      color: #fff;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
    }
    .row-2 {
      margin-top: 2px;
      color: rgba(255, 255, 255, 0.4);
      line-height: 16px;
      font-size: 10px;
    }
  }
}
</style>
